import { NodeSpec } from 'prosemirror-model';

import { BaseExtension } from '@lyearn/lygo-core';

import { getTableNode } from '../Table/utils';
import { NODE_NAME } from './consts';
import plugins from './plugins';

export default class TableRow extends BaseExtension {
  get schema(): NodeSpec {
    return getTableNode('table_row');
  }

  get name(): string {
    return NODE_NAME;
  }

  plugins = plugins;
}
